module.exports = __webpack_public_path__ + "static/nederland_ict_logo-c638aac996958479bbbabf55942b3228.jpg";